import {
  type IncomeStatementExportRequestInput,
  type ReportExport,
  type ReportExportList,
  reportExportListSchema,
  reportExportSchema,
} from '@jaf/contracts';
import type { ReportScopeQuery } from '@/features/company-scope';
import { httpClient, requestJson } from '@/shared/api';

/** Pedido de exportação da DRE: formato, filtros, análises e o escopo do cabeçalho. */
export type IncomeStatementExportInput = Omit<
  IncomeStatementExportRequestInput,
  'scope' | 'companyIds'
> &
  ReportScopeQuery;

/** Pede a exportação da DRE; pequena já volta pronta (`READY`), grande volta na fila. */
export function requestIncomeStatementExport(
  input: IncomeStatementExportInput,
): Promise<ReportExport> {
  const { companyIds, ...body } = input;
  return requestJson(httpClient, reportExportSchema, {
    method: 'POST',
    url: '/income-statement/exports',
    data: companyIds === undefined ? body : { ...body, companyIds: companyIds.join(',') },
  });
}

/** Exportações recentes do usuário (não expiradas). */
export function fetchReportExports(signal?: AbortSignal): Promise<ReportExportList> {
  return requestJson(httpClient, reportExportListSchema, {
    method: 'GET',
    url: '/report-exports',
    ...(signal === undefined ? {} : { signal }),
  });
}

/** Conteúdo do arquivo pronto, com o tipo informado pela API. */
export async function fetchReportExportFile(reportExport: ReportExport): Promise<Blob> {
  const response = await httpClient.request<ArrayBuffer>({
    method: 'GET',
    url: `/report-exports/${reportExport.id}/file`,
    responseType: 'arraybuffer',
  });
  const contentType = response.headers['content-type'];
  return new Blob([response.data], {
    type: typeof contentType === 'string' ? contentType : 'application/octet-stream',
  });
}
